<template>
  <div
    v-if="item.displayRedemptionTotal > 0"
    class="column"
  >
    <div class="row q-gutter-x-xs">
      <i18n-n
        class="text-bold"
        tag="span"
        :class="{ [`text-${color}`]: true }"
        :value="item.displayPrice - item.displayRedemptionTotal"
        format="currency"
        data-test-id="cart-item-display-total"
      />
      <i18n-n
        class="text-strike"
        tag="span"
        :class="{ [`text-${color}`]: true }"
        :value="item.displayPrice"
        format="currency"
        data-test-id="cart-item-display-price"
      />
    </div>
    <div
      class="text-caption text-left text-red"
    >
      Saving
      <i18n-n
        class="text-red"
        tag="span"
        :value="item.displayRedemptionTotal"
        format="currency"
        data-test-id="cart-item-redemption-total"
      />
    </div>
  </div>
  <div
    v-else
  >
    <i18n-n
      class="text-bold"
      :class="{ [`text-${color}`]: true }"
      tag="span"
      :value="item.displayPrice"
      format="currency"
      data-test-id="cart-item-display-total"
    />
  </div>
</template>

<script>

export default {
  name: 'Price',
  props: {
    item: {
      type: Object,
      required: true,
      default: null
    },
    color: {
      type: String,
      required: false,
      default: 'responsive'
    }
  }
}

</script>
